import React, { useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, CardContent, Grid, Tab } from "@mui/material";
import Loaders from "../common/Loaders";
import JobsTable from "../common/JobsTable";
import { JOB_SERVER_URL } from "../../config";
import { useUserAuth } from "../../context";
import { useAppDispatch } from "../../app/hooks";
import http from "../../net/http-common";
import { errorMessages } from "../../common_variables/ErrorMsgs";
import { isAxiosError } from "axios";
import { setGlobalMsgAlerts } from "../GloablMsgAlerts/globalMsgAlertsSlice";


function LodestarJobs() {
  const [tabValue, setTabValue] = useState("1");
  const [doLoadJobs, setDoLoadJobs] = useState(true);
  const [mdSimulationRows, setMdSimulationJobs] = useState([]);
  const [postMdSimulationRows, setPostMdSimulationJobs] = useState([]);
  const [rbfeRows, setRbfeJobs] = useState([]);
  const { user } = useUserAuth();
  const globalDispatch = useAppDispatch();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    try {
      if (!doLoadJobs || !user) return;

      async function getSubmittedJobs() {
        const rbfeResult = await http.get(`${JOB_SERVER_URL}/userjobs`, {
          params: {
            user_id: user.uid,
            model_name: "rbfe",
            start: "0",
            end: "10",
          },
          headers: {
            accept: "application/json",
          },
        });

        const mdResult = await http.get(`${JOB_SERVER_URL}/userjobs`, {
          params: {
            user_id: user.uid,
            model_name: "md_simulation",
            start: "0",
            end: "10",
          },
          headers: {
            accept: "application/json",
          },
        });

        const nciResult = await http.get(`${JOB_SERVER_URL}/userjobs`, {
          params: {
            user_id: user.uid,
            model_name: "nci",
            start: "0",
            end: "10",
          },
          headers: {
            accept: "application/json",
          },
        });

        setRbfeJobs(rbfeResult.data);
        setMdSimulationJobs(mdResult.data);
        setPostMdSimulationJobs(nciResult.data);
        setDoLoadJobs(false);
      }
      getSubmittedJobs();
    } catch (error) {
      setDoLoadJobs(false);
      let msg = "";
      if (isAxiosError(error)) {
        msg = error.response?.data?.detail?.message;
      }
      globalDispatch(setGlobalMsgAlerts({
        msg: msg || errorMessages.jobTableError,
        isAlert: true,
        color: "error",
      }));
    }
  }, [doLoadJobs]);

  const onSuccessfullJobSubmission = (job_id: number) => {
    setDoLoadJobs(true);
    setTabValue("3");
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className="jobs-container"
      mt={2}
      mb={2}
      px={3}
    >
      <Card sx={{ width: 1 }}>
        <CardContent>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                value={tabValue}
                onChange={handleTabChange}
                aria-label="filter tabs"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="RBFE Calculations" value="1" />
                <Tab label="MD Simulations" value="2" />
                <Tab label="NCI Analysis" value="3" />
              </TabList>
            </Box>
            {/* rbfe calculations */}
            <TabPanel
              value="1"
              sx={{
                p: 0,
                mt: 0.5,
              }}
            >
              {doLoadJobs && <Loaders type={"table"} />}
              {!doLoadJobs && (
                <JobsTable
                  jobs={rbfeRows}
                  setDoLoadJobs={setDoLoadJobs}
                  nextUrl="rbfe/visualize"
                  // disableVisualize={true}
                ></JobsTable>
              )}
            </TabPanel>
            {/* md simulation */}
            <TabPanel
              value="2"
              sx={{
                p: 0,
                mt: 0.5,
              }}
            >
              {doLoadJobs && <Loaders type={"table"} />}
              {!doLoadJobs && (
                <JobsTable
                  jobs={mdSimulationRows}
                  setDoLoadJobs={setDoLoadJobs}
                  // nextUrl="md/visualize"
                  disableDownload={true}
                  onSuccessfullJobSubmission={onSuccessfullJobSubmission}
                  // onFailedJobSubmission={onFailedJobSubmission}
                ></JobsTable>
              )}
            </TabPanel>
            {/* post md simulation */}
            <TabPanel
              value="3"
              sx={{
                p: 0,
                mt: 0.5,
              }}
            >
              {doLoadJobs && <Loaders type={"table"} />}
              {!doLoadJobs && (
                <JobsTable
                  jobs={postMdSimulationRows}
                  setDoLoadJobs={setDoLoadJobs}
                  nextUrl="nci/visualize"
                  // disableVisualize={true}
                  disableDownload={true}
                ></JobsTable>
              )}
            </TabPanel>
          </TabContext>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default LodestarJobs;
